module.exports = __webpack_public_path__ + "img/intro.3ad34a40.3ad34a40.jpg";